import { render, staticRenderFns } from "./VlModalActionAttachment.vue?vue&type=template&id=0f6e7c54&scoped=true&"
import script from "./VlModalActionAttachment.vue?vue&type=script&lang=js&"
export * from "./VlModalActionAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e7c54",
  null
  
)

export default component.exports